export const cleanupAuthState = () => {
  try {
    // Remove standard auth tokens
    localStorage.removeItem('supabase.auth.token');
    
    // Remove all Supabase auth keys from localStorage
    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith('supabase.auth.') || 
          key.includes('sb-')) {
        localStorage.removeItem(key);
      }
    });
    
    // Remove from sessionStorage if in use
    try {
      Object.keys(sessionStorage || {}).forEach((key) => {
        if (key.startsWith('supabase.auth.') || 
            key.includes('sb-')) {
          sessionStorage.removeItem(key);
        }
      });
    } catch {}
    
    // Clear any cached user data
    sessionStorage.removeItem('user_subscription_cache');
    localStorage.removeItem('user_subscription_cache');
    
  } catch (error) {
    console.warn('Error during auth cleanup:', error);
  }
};
